// Module
var code = `<h4 translate>Check Instructions</h4> <ol> <li translate>Print this page.</li> <li> <translate>Make your check payable to</translate> "{{conference.checkPayableTo}}". </li> <li> <translate>Mail this page and your check to:</translate><br/><br/> {{conference.checkMailingAddress}}<br/> {{conference.checkMailingCity}}, {{conference.checkMailingState}} {{conference.checkMailingZip}} </li> </ol> `;
// Exports
var _module_exports =code;;
var path = '/views/paymentMethods/check.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;